<template>
    <div>

        <div class="content-top row">
            <div class="col-24 d-flex justify-content-between align-items-center">
                <div class="content-top__title-box">
                    <h1 class="content-top__heading">Lista rodzin produktów</h1>
                    <div class="content-top__subheading" v-if="!isLoading">
                        <span v-html="(objects.length) ? objects.length : '0'"></span>
                        {{ objects.length | numeralsText('rodzina', 'rodziny', 'rodzin') }}
                    </div>
                </div>
                <button class="button button--icon" @click="addObject()" v-if="!isLoading">
                    <icon icon="plus" icon-classes="button__icon button__icon--left icon--white icon__plus--small" />
                    <span class="button__text">Dodaj nową rodzinę</span>
                </button>
            </div>
        </div>

        <div class="content row">

            <template v-if="isLoading">
                <div class="col-24">
                    Trwa ładowanie obiektów...
                </div>
            </template>
            <template v-else>
                <div class="col-24">
                    <table class="items-table">
                        <thead class="items-table__thead">
                            <tr class="items-table__tr">
                                <th class="items-table__th">
                                    ID
                                </th>
                                <th class="items-table__th">
                                    Nazwa
                                </th>
                                <th class="items-table__th">
                                    Kolejność
                                </th>
                                <th class="items-table__th p-0 text-right">
                                    Akcje
                                </th>
                            </tr>
                        </thead>

                        <tbody class="items-table__tbody">
                            <template v-for="object in objects">
                                <tr class="items-table__tr" v-bind:key="object.id">
                                    <td class="items-table__td">
                                        <div class="form-box__mobile-element">Id</div>
                                        {{ object.id }}
                                    </td>

                                    <td class="items-table__td items-table__td--expand">
                                        <div class="form-box__mobile-element">Nazwa</div>
                                        {{ object.name }}
                                    </td>

                                    <td class="items-table__td items-table__td--nowrap">
                                        <div class="form-box__mobile-element">Kolejność</div>
                                        <input type="number" min="1" step="1" :readonly="isOrderChanging" @keypress="onlyNumber" v-model="object.order" @input="changeOrderDebounce(object)" class="form-box__input"/>
                                    </td>

                                    <td class="items-table__td items-table__td--button">
                                        <div class="form-box__mobile-element">Akcje</div>
                                        <div class="d-flex justify-content-end">
                                            <button class="button-icon" @click.prevent="reorderProductsModal(object)">
                                                <icon icon="reverse-pion" />
                                            </button>

                                            <button class="button-icon button-icon--ml-10" @click.prevent="editObject(object)">
                                                <icon icon="edit" />
                                            </button>

                                            <button class="button-icon button-icon--ml-10" @click="deleteObject(object)">
                                                <icon icon="trash" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </template>

        </div>

        <!-- Modal add/edit -->
        <modal :show="showModal" size="lg" @close="showModal = !showModal">
            <div slot="header" class="notice-modal__header--title">
                <span v-text="(!isEditing) ? 'Dodawanie rodziny' : 'Edycja rodziny'"></span>
            </div>

            <div slot="body">

                <div class="row">
                    <div class="col-24">
                        <div class="product-form__title">Nazwa</div>
                        <input class="product-form__input" type="text" v-model="object.name" required />
                    </div>
                </div>

            </div>

            <div slot="footer" class="d-flex align-items-center">
                <button class="button button--small button--grey" @click="showModal = false" :disabled="isStoring">
                    Anuluj
                </button>
                <button class="button button--small button--ml-10" @click="storeObject()" :disabled="isStoring"
                    v-text="(isStoring) ? 'Zapisuję...' : 'Zapisz'">
                    Zapisz
                </button>
            </div>
        </modal>

        <!-- Modal reorder products -->
        <modal :show="showModalReorder" size="lg" @close="showModalReorder = !showModalReorder">
            <div slot="header" class="notice-modal__header--title">
                Zmiana kolejności produktów w rodzinie {{ object.name }}
            </div>

            <div slot="body">

                <div class="row" v-if="objectProducts.length > 0">
                    <div class="col-24">
                        <table class="items-table">
                            <thead class="items-table__thead">
                                <tr class="items-table__tr">
                                    <th class="items-table__th">
                                        ID
                                    </th>
                                    <th class="items-table__th">
                                        Nazwa
                                    </th>
                                    <th class="items-table__th">
                                        Kolejność
                                    </th>
                                </tr>
                            </thead>

                            <tbody class="items-table__tbody">
                                <tr class="items-table__tr" v-for="product in objectProducts" :key="product.id">
                                    <td class="items-table__td">
                                        <div class="form-box__mobile-element">Id</div>
                                        {{ product.id }}
                                    </td>

                                    <td class="items-table__td items-table__td--expand">
                                        <div class="form-box__mobile-element">Nazwa</div>
                                        {{ product.name }}
                                    </td>

                                    <td class="items-table__td items-table__td--nowrap">
                                        <div class="form-box__mobile-element">Kolejność</div>
                                        <input type="number" min="1" step="1" :readonly="isOrderChanging" @keypress="onlyNumber" v-model="product.family_order" @input="changeProductOrderDebounce(product)" class="form-box__input"/>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-else v-text="(!objectProducts) ? 'Wczytuję produkty...' : 'Brak produktów.'"></div>

            </div>

            <div slot="footer" class="d-flex align-items-center">
                <button class="button button--small button--grey" @click="showModalReorder = false" :disabled="isStoring">
                    Anuluj
                </button>
                <button class="button button--small button--ml-10" @click="storeObject()" :disabled="isStoring"
                    v-text="(isStoring) ? 'Zapisuję...' : 'Zapisz'">
                    Zapisz
                </button>
            </div>
        </modal>

        <!-- Modal delete -->
        <modal :show="showDeleteModal" size="md" @close="showDeleteModal = !showDeleteModal">
            <div slot="header" class="notice-modal__header--title">
                Usuwanie rodzin
            </div>

            <div slot="body">
                <div>Czy na pewno chcesz usunąć rodzinę
                    <strong>{{ '#' + objectToDelete.id + ' - ' + objectToDelete.name }}</strong>?</div>
            </div>

            <div slot="footer" class="d-flex align-items-center">
                <button class="button button--small button--grey" @click="showDeleteModal = false">
                    Nie
                </button>
                <button class="button button--small button--ml-10" @click="confirmDeleteObject()">
                    Tak
                </button>
            </div>
        </modal>
    </div>
</template>

<script>
    import axios from 'axios';
    const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
    import Icon from './../parts/Icon';
    import Modal from './../parts/Modal';
    import _ from 'lodash';

    export default {
        data() {
            return {
                object: {},
                objectProducts: false,
                objects: {},
                showModal: false,
                showModalReorder: false,
                showDeleteModal: false,
                isEditing: false,
                isStoring: false,
                isLoading: true,
                isOrderChanging: false,
                imagePath: false,
                objectToDelete: {}
            }
        },
        components: {
            Icon,
            Modal
        },
        async created() {
            this.getObjects();
        },
        methods: {
            async storeObject() {
                let vm = this;
                let data = this.object;
                this.isStoring = true;

                try {

                    const config = {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }

                    let formData = new FormData();
                    if (data.id) {
                        formData.append('id', data.id);
                    }
                    if (data.name) {
                        formData.append('name', data.name);
                    }

                    const response = await axios.post(API_BASE_URL + '/product-families', formData, config);

                    vm.objects = response.data;
                    vm.object = {};
                    vm.showModal = false;
                    vm.isStoring = false;

                } catch (error) {
                    vm.isStoring = false;
                    vm.$root.$emit('noticesBox', error.response.data);
                }
            },
            async getObjects() {
                try {
                    const response = await axios.get(API_BASE_URL + '/product-families');
                    this.objects = response.data;
                } catch (error) {
                    this.$root.$emit('noticesBox', error.response.data);
                }
                this.isLoading = false;
            },
            editObject(object) {
                this.object = _.cloneDeep(object);
                this.isEditing = true;
                this.showModal = true;
            },
            addObject() {
                this.object = {};
                this.isEditing = false;
                this.showModal = true;
            },
            async deleteObject(object) {
                this.showDeleteModal = true;
                this.objectToDelete = object;
            },
            async confirmDeleteObject() {
                this.showDeleteModal = false;
                try {
                    await axios.delete(API_BASE_URL + '/product-families/' + this.objectToDelete.id);
                    this.getObjects();
                } catch (error) {
                    this.$root.$emit('noticesBox', error.response.data);
                }
            },
            changeOrderDebounce: _.debounce(function (object) {
                this.changeOrder(object);
            }, 400),
            changeProductOrderDebounce: _.debounce(function (product) {
                this.changeProductOrder(product);
            }, 400),
            async changeOrder(object) {
                this.isOrderChanging = true;

                try {
                    let response = await axios.post(API_BASE_URL + '/product-families/change-order', object);

                    this.isOrderChanging = false;
                    this.objects = response.data;

                    this.$root.$emit('noticesBox', {
                        type: 'success',
                        message: 'Poprawnie zmieniono kolejność rodziny <strong>' + object.name + '</strong>.'
                    });

                } catch (error) {
                    this.isOrderChanging = false;

                    this.$root.$emit('noticesBox', error.response.data);
                }
            },
            async changeProductOrder(product) {
                this.isOrderChanging = true;

                try {
                    let response = await axios.post(API_BASE_URL + '/product-families/change-product-order', product);

                    this.isOrderChanging = false;
                    this.objectProducts = response.data;

                    this.$root.$emit('noticesBox', {
                        type: 'success',
                        message: 'Poprawnie zmieniono kolejność produktu <strong>' + product.name + '</strong>.'
                    });

                } catch (error) {
                    this.isOrderChanging = false;

                    this.$root.$emit('noticesBox', error.response.data);
                }
            },
            async reorderProductsModal(object) {
                this.showModalReorder = true;
                this.object = _.cloneDeep(object);
                this.objectProducts = false;

                try {
                    let response = await axios.get(API_BASE_URL + '/product-families/' + object.id + '/products');

                    this.objectProducts = response.data;

                } catch (error) {
                    this.$root.$emit('noticesBox', error.response.data);
                }

            },
            onlyNumber ($event) {
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                    $event.preventDefault();
                }
            }
        }
    }
</script>